<script setup lang="ts">
import { Card } from 'primevue';

const props = defineProps({
  content: {
    type: Array,
    default: [],
  },
});

const categories = computed(() => props.content);
</script>

<template>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
    <div
      v-for="(item, index) in categories"
      :key="index"
      class="p-px rounded-2xl md:!max-w-[390px] !w-full !h-full"
      :class="
        index % 2 === 0
          ? 'bg-[image:var(--border-card-odd)]'
          : 'bg-[image:var(--border-card-even)]'
      "
    >
      <div
        class="overflow-hidden rounded-2xl h-full"
        :class="
          index % 2 === 0
            ? 'bg-[image:var(--bg-card)]'
            : 'bg-[image:var(--bg-card-even)]'
        "
      >
        <Card
          unstyled
          class="relative  overflow-hidden px-8 py-4 text-white after:content-[''] after:absolute after:right-10 after:-top-40 after:w-[65px] after:h-[400px] after:rotate-[30deg] after:blur-[50px]"
          :class="
            index % 2 === 0
              ? 'after:bg-[linear-gradient(180.37deg,_#737CD3_29.35%,_#1B0742_131.96%)]'
              : 'after:bg-[linear-gradient(180.37deg,_#A066C7_29.35%,_#3B0C5B_131.96%)] '
          "
          :pt="{
            body: {
              class: 'h-full relative z-10',
            },
            root: {
              class: 'h-full',
            },
            content: {
              class: 'h-full flex flex-col justify-between',
            },
          }"
        >
          <template #content>
            <!-- <div class="relative z-10"> -->
              <p class="text-base">{{ item.description }}</p>
              <div class="flex items-center gap-4 mt-4">
                <div
                  class="p-px bg-[linear-gradient(180deg,_#F5F2FF_0%,_#C4C2E0_100%)] rounded-full"
                >
                  <NuxtImg
                    alt="authImg"
                    :src="item.authImg"
                    width="64"
                    height="64"
                    loading="lazy"
                    class="rounded-full p-[2px] bg-[image:var(--border-testimonial-card)]"
                     format="webp"
                  />
                </div>
                <div class="relative z-10">
                  <p class="text-base relative z-10">{{ item.authName }}</p>
                  <p class="text-[#E9AFE7] text-base relative z-10">
                    {{ item.authRole }}     
                  </p>
                </div>
              </div>
            <!-- </div> -->
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>
